import { combineEpics, ofType } from 'redux-observable';
import { map, pluck, tap } from 'rxjs/operators';

import { history } from 'src/config/history';
import { Epic } from 'src/config/rootEpic';
import { UrlWithState } from 'src/modules/navigation/models/navigationModels';
import { noop } from 'src/shared/actions/sharedActions.ts';

import { REDIRECT_TO_URL, REDIRECT_TO_URL_WITH_STATE } from '../actions/navigationActions';

export function navigationRedirectEpicFactory(): Epic {
    const navigationRedirectEpic: Epic = action$ =>
        action$.pipe(
            ofType(REDIRECT_TO_URL),
            pluck('payload'),
            tap((url: string) => history.push(url)),
            map(noop),
        );

    const navigationRedirectWithStateEpic: Epic = action$ =>
        action$.pipe(
            ofType(REDIRECT_TO_URL_WITH_STATE),
            pluck('payload'),
            tap((obj: UrlWithState) => history.push(obj.url, obj.state)),
            map(noop),
        );

    return combineEpics(navigationRedirectEpic, navigationRedirectWithStateEpic);
}
